<template>
  <button
    :class="['btn btn-sm', onlyIcon ? ' btn-ghost' : 'btn-outline']"
    @click="showShare = true"
  >
    <i class="iconfont icon-share text-sm"></i>
    <span v-if="!onlyIcon">{{ shareName || t(`share.name`) }}</span>
  </button>

  <!-- <VanShareSheet
    v-model:show="showShare"
    :options="options"
    :title="t(`share.title`)"
    @select="clickShare"
    :cancel-text="t(`Buttons.cancel`)"
  /> -->
  <VanPopup
    v-model:show="showShare"
    class="p-6"
    position="bottom"
    round
    teleport="body"
  >
    <div>
      <div class="flex justify-center items-center mb-10">
        <span class="text-lg">{{ t(`share.title`) }}</span>
      </div>
      <div class="flex gap-6">
        <div
          class="flex flex-col items-center gap-2 cursor-pointer"
          @click="clickShare(0)"
        >
          <div
            class="flex items-center justify-center rounded-full bg-primary text-primary-content w-[50px] h-[50px]"
          >
            <i class="iconfont icon-moment1 text-[40px]" />
          </div>
          <p class="text-xs">{{ t(`share.moment`) }}</p>
        </div>
        <div
          class="flex flex-col items-center gap-2 cursor-pointer"
          @click="clickShare(1)"
        >
          <div
            class="flex items-center justify-center rounded-full bg-primary text-primary-content w-[50px] h-[50px]"
          >
            <i class="iconfont icon-connection text-[20px]" />
          </div>
          <p class="text-xs">{{ t(`share.copyLink`) }}</p>
        </div>
      </div>
      <div>
        <button class="btn btn-ghost w-full mt-4" @click="showShare = false">
          {{ t(`Buttons.cancel`) }}
        </button>
      </div>
    </div>
  </VanPopup>
  <ShareWithMoment
    v-model:show="showMoment"
    :share-id="shareId"
    :share-type="shareType"
    :story-game-id="storyGameId"
  />
</template>

<script lang="ts" setup>
import { copyToClipboard } from "@/modules/common";
import { showSuccessToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const showShare = ref(false);
const { t } = useI18n();
defineProps({
  onlyIcon: {
    type: Boolean,
    default: false,
  },
  shareName: {
    type: String,
    default: "",
  },
  shareType: {
    type: String,
    required: true,
  }, // collection, game, story, user
  shareId: {
    type: Number,
    required: true,
  },
  storyGameId: {
    type: Number,
  },
  userId: {
    type: Number,
  },
});

const clickShare = (idx: number) => {
  if (idx === 0) {
    // Share to Moments
    showMoment.value = true;
  } else if (idx === 1) {
    const { pathname, search } = location;
    // copyToClipboard(location.href);
    copyToClipboard(`${location.origin}${pathname}${search}`);
    showSuccessToast(t(`Message.copySuccessful`));
  }
  showShare.value = false;
};
const showMoment = ref(false);
</script>
